// extracted by mini-css-extract-plugin
module.exports = {"header":"filterNav_header__ZnpEv","btnReset":"filterNav_btnReset__kPK1X","hideBtnReset":"filterNav_hideBtnReset__jmB7_","heading":"filterNav_heading__CFXm1"};